<template>
    <div class="lease-management-default parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <modal class="new-contract" :display="newContract"  @modalStatus="closeModal('newContract')" >
            <h1>請問您要新增哪種合約？</h1>
            <div class="content">
                <contract-type @getLink="contractLink"></contract-type>
            </div>
            <div class="btn-group">
                <router-link :to="{ name: newContractLink}">
                    <button class="default-button" @click="closeModal('newContract')">確認</button>
                </router-link>
                <button class="border-button" @click="closeModal('newContract')">取消</button>
            </div>
        </modal>
        <auto-setting-batch @saveAutoStatus="alart.success = true, msg.success = '通知設定成功'"></auto-setting-batch>
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
            <span v-if="msg.successDes" class="description" slot="description">{{msg.successDes}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <div class="tool-bar-mask"></div>
        <lease-filter :isOpen="leaseFilter" @filterClose="closeFilterMenu" @changeFilter="setFilterQuery"></lease-filter>
        <h1>租約管理</h1>
        <div class="btn-group" :class="{notify: selected.done == true}">
            <div v-if="selected.done == true" class="border-button" @click="setAutoSetting">
                通知設定
            </div>
            <drop-menu refName="kk" dropMenuMsg="更多功能" border="1px solid #ff9275" bgColor="#ff9275" arrowColor="white">
                <ul>
                    <li data-id="1" @click="newContractEvent()">
                        建立合約
                    </li>
                    <router-link :to="{ name: 'contractVersion'}">
                        <li data-id="2">
                            編輯合約版本
                        </li>
                    </router-link>
                </ul>
            </drop-menu>
            <table-search @changeWord="setFilterWord" :setDefault="filterWordIsEmpty"></table-search>
            <!-- <div class="filter" @click="leaseFilter = true">
                <img src="../../../assets/img/icon/filter_white.svg" alt="">
            </div> -->
        </div>
        <tabs :key="componentKey">
            <tab name="正在進行" :selected="selected.done">
                <lease-done-list></lease-done-list>
            </tab>
            <tab name="紙本確認中" :selected="selected.beSigned">
                <lease-be-signed-list></lease-be-signed-list>
            </tab>
            <tab name="結束合約" :selected="selected.finished">
                <lease-finished-list></lease-finished-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import AutoSettingBatch from '@/components/widge/AutoSettingBatch.vue';
import LeaseDoneList from '@/components/landlord/leaseManagement/LeaseDoneList.vue';
import LeaseFinishedList from '@/components/landlord/leaseManagement/LeaseFinishedList.vue';
import LeaseBeSignedList from '@/components/landlord/leaseManagement/LeaseBeSignedList.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import LeaseFilter from '@/components/landlord/leaseManagement/LeaseFilter.vue';
import Modal from '@/components/widge/Modal.vue';
import ContractType from '@/components/widge/ContractType.vue';
import DropMenu from '@/components/widge/DropMenu.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            hash: null,
            leaseFilter: false,
            listIsFixed: false,
            alart: false,
            newContract: false,
            newContractLink: null,
            myHeight: (window.innerHeight) + 'px',
            selected: {
                done: false,
                beSigned: false,
                finished: false,
            },
            componentKey: 0,
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                successDes: null,
                error: null,
            }
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        // console.log(this.$route.query.success)
        // if( this.$route.query.success && this.$route.query.success == 1){
        //     this.alart = true
        //     this.$router.replace('/landlord/leasemanagement/home')
        // }
        this.$analytics.logEvent('租約管理', { screen_name: '租約管理'})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.hash = val.hash
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        closeFilterMenu: function (value) {
            this.leaseFilter = value
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        setFilterWord: function (value) {
            this.$store.dispatch('setFilterWord', value)
        },
        setFilterQuery: function (value) {
            this.$store.dispatch('setFilterQuery', value)
        },
        setAutoSetting: function () {
            this.componentKey += 1
            this.$store.dispatch('setModalStatus', {state: true, type: 'autoSettingBatch'})
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlart: function () {
            this.alart = false
        },
        newContractEvent: function () {
            this.newContract = true
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.$store.commit('newContract/set_contract_status', 1)
        },
        closeModal: function (type) {
            if( type == 'newContract' ){
                this.$store.dispatch('sendEventLog', 'PAPER_CONTRACT')
                this.newContract = false
                this.$store.commit('modalStatus/set_modal_mode', false)
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            }
        },
        contractLink: function (val) {
            this.newContractLink = val
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            console.log(hashTag)
            if( hashTag == '#正在進行' ){
                this.$analytics.logEvent('租約管理_正在進行', { screen_name: '租約管理_正在進行'})
                this.selected.done = true
            }else if( hashTag == '#紙本確認中' ){
                this.$analytics.logEvent('租約管理_紙本確認中', { screen_name: '租約管理_紙本確認中'})
                this.selected.beSigned = true
            }else if( hashTag == '#結束合約' ){
                this.$analytics.logEvent('租約管理_結束合約', { screen_name: '租約管理_結束合約'})
                this.selected.finished = true
            }else{
                this.$analytics.logEvent('租約管理_正在進行', { screen_name: '租約管理_正在進行'})
                this.selected.done = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.done = false
            this.selected.beSigned = false
            this.selected.finished = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
        
    },
    computed: {
        ...mapGetters({
            filterWordIsEmpty: 'GET_LEASE_MGT_FILTER_WORD_IS_EMPTY',
            isModalMode: 'GET_MODAL_MODE'

        })
    },
    components: {
        Tabs,
        Tab,
        LeaseBeSignedList,
        LeaseDoneList,
        LeaseFinishedList,
        TableSearch,
        LeaseFilter,
        AlartMsg,
        Modal,
        ContractType,
        AutoSettingBatch,
        DropMenu
    }
}
</script>
<style lang="scss">
    .lease-management-default{
        position: relative;
        margin-top: 102px;
        margin-bottom: 100px;
        h1{
            margin-top: 10px;
            margin-bottom: 40px;
        }
        > .btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: -10px;
            right: 20px;
            .border-button{
                width: 120px;
                padding: 13px 0;
                margin-right: 16px;
            }
            .insert-contract{
                display: flex;
                align-items: center;
                width: 92px;
                height: 44px;
                cursor: pointer;
                border-radius: 4px;
                background-color: #ff9275;
                color: #fff;
                margin-right: 16px;
                padding: 0 14px;
            }
            .filter{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                cursor: pointer;
                background: #a8a5a4;
                border-radius: 4px;
                margin-left: 16px;
            }
            .drop-menu{
                padding: 12px 14px 12px 24px;
                height: 18px;
                margin-right: 16px;
                span{
                    font-weight: 500;
                }
                ul{
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    width: 187px;
                    right: 0px;
                    li{
                        // padding: 12px 16px;
                        img{
                            width: 20px;
                            height: 20px;
                            // background-color: #f0f0f0;
                            margin-right: 15px;
                        }
                    }
                }
            }
            // .drop-menu:nth-child(1){
            //     height: 18px;
            //     margin-right: 16px;
            //     span{
            //         font-weight: 500;
            //         color: #ff9275;
            //     }
                
            // }
            .drop-menu:nth-child(1){
                height: 18px;
                span{
                    font-weight: 500;
                    color: #fff;
                }
            }
        }
        .tabs{
            position: absolute;
            top: 2px;
            left: 150px;
            ul li.is-active :after{
                bottom: -4px;
            }
        }
        .new-contract{
            .modal-content{
                width: 520px;
                height: 437px;
                padding: 0 !important;
                .detail{
                    align-items: unset !important;
                    h1{
                        margin-top: 36px;
                        margin-bottom: 40px;
                        margin-left: 32px;
                    }
                    .content{
                        padding: 0 32px 10px 32px;
                        height: 182px;
                        margin-bottom: 52px;
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                        button:first-child{
                            margin-right: 14px;
                        }
                    }
                }
                
            }
        }
    }
    .lease-management-default.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        >h1{
            position: fixed;
            top: 14px;
            z-index: 8;
        }
        >.btn-group{
            position: fixed;
            top: 18px;
            right: unset;
            z-index: 8;
            margin-left: 790px;
        }
        >.btn-group.notify{
            margin-left: 650px;
        }
        .tabs{
            position: fixed;
            margin-left: 152px;
            top: 27px;
            left: unset;
            z-index: 8;
        }
        .tabs-details{
            position: relative;
            padding-top: 59px;
            border-radius: 0 0 10px 10px;
            .lease-done,
            .lease-finished{
                border-radius: 0 0 10px 10px;
                .mask{
                    position: fixed;
                    background: #f6f6f6;
                    width: 1190px;
                    height: 50px;
                    top: 81px;
                    margin-left: -15px;
                    z-index: 9;
                }
                .table-list-title{
                    position: fixed;
                    background: #fff;
                    top: 96px;
                    border-radius: 10px 10px 0 0 ;
                    z-index: 9;
                }
            
            }
            
        }
    }
    @media screen and (max-width: 1280px) {
        .lease-management-default{
            .btn-group{
                right: 0px;
            }
        }
        .lease-management-default.fixed{
            .tool-bar-mask{
                margin-left: -24px;
            }
            >.btn-group{
                margin-left: 776px;
            }
            .tabs-details{
                .table-list{
                    .table-list-title{
                        // width: 1082px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/LeaseManagementPages/LeaseManagementDefault.vue